import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import { safeArea } from '../../styles/css';
import Frame from './Frame';
import SituationSkeleton from './SituationSkeleton';

const skeletonCSS = css`
  .cover {
    padding-bottom: 62.5%;
    ${safeArea('top')};
  }
  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${Spacing.xhsmall}px;
    margin-top: ${Spacing.xxlarge}px;

    div {
      width: 60%;
      height: 12px;
    }
    div:nth-of-type(1) {
      width: 20%;
      height: 20px;
      margin-bottom: ${Spacing.xxsmall}px;
    }
    div:last-of-type {
      width: 30%;
      height: 16px;
      margin-top: ${Spacing.xxsmall}px;
    }
  }
  .button {
    display: flex;
    justify-content: center;
    gap: ${Spacing.xxsmall}px;
    padding: ${Spacing.large}px;
    margin-bottom: ${Spacing.medium}px;

    div {
      width: 130px;
      height: 40px;
    }
    div:last-of-type {
      width: 40px;
      height: 40px;
    }
  }
  .situation {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0 ${Spacing.medium}px;
    column-gap: ${Spacing.small}px;
    row-gap: ${Spacing.xlarge}px;
  }
`;

const CharacterDetailSkeleton = () => {
  return (
    <div css={skeletonCSS}>
      <Frame className="cover" />
      <div className="info">
        <Frame />
        <Frame />
        <Frame />
        <Frame />
      </div>
      <div className="button">
        <Frame />
        <Frame />
        <Frame />
      </div>
      <div className="situation">
        <SituationSkeleton isDetail />
        <SituationSkeleton isDetail />
        <SituationSkeleton isDetail />
        <SituationSkeleton isDetail />
        <SituationSkeleton isDetail />
        <SituationSkeleton isDetail />
      </div>
    </div>
  );
};

export default CharacterDetailSkeleton;
